define([
    'lodash',
    'common/utils'
], function(
    _,
    Utils
){
    var product = {};
    function Product(data){
        _.assign(this, data);
        this.updateSku();
    }
    Product.prototype.updateSku = function(){
        this.selectedSku = this.getSelectedSku();
        this.selectedSkuExtra = this.getSelectedSkuExtra();
    };
    Product.prototype.getSelectedSku = function(){
        var _this = this;
        var skuKey = _.map(this.spu.categorySpec, function(o){
            var item = _.find(_this.skuSpec, {bom: o.bom});
            return item ? item.val : '';
        }).join('') || '';
        console.log(skuKey);
        return this.spu.sku[skuKey] || {};
    };
    Product.prototype.getSelectedSkuExtra = function(){
        var selectedSku = this.getSelectedSku();
        if (!selectedSku) return null;
        return _.find(this.spuExtra.skuTable, {bom: selectedSku.bom});
    };
    //获取第一个可以选中的spec
    Product.prototype.checkSpecCanSelect = function(bom, val) {

        //先赋值第一个
        var item = _.find(this.skuSpec, {bom: bom});
        item.val = val;

        var unSelectBom = [];
        for(var i=0; i<this.spu.categorySpec.length; i++)
        {
            if(this.spu.categorySpec[i].bom != bom)
            {
                unSelectBom.push(this.spu.categorySpec[i].bom);
            }
        }

        //2个规格以内的处理
        if(this.skuSpec.length <=2)
        {
            for (var i=this.skuSpec.length-1 ;i>=0; i--)
            {
                if(this.skuSpec[i].bom == bom)
                    continue;

                for(var j=0; j< this.spu.categorySpecValue[this.skuSpec[i].bom].length; j++)
                {
                    this.skuSpec[i].val = this.spu.categorySpecValue[this.skuSpec[i].bom][j];

                    if(this.canSelectSpec('', ''))
                    {
                        return;
                    }
                }
            }
        }
        //三个规格的处理
        else
        {
            for(var m=0; m<this.spu.categorySpecValue[unSelectBom[0]].length; m++)
            {
                var itemL2 = _.find(this.skuSpec, {bom: unSelectBom[0]});
                itemL2.val = this.spu.categorySpecValue[unSelectBom[0]][m];

                for(var n=0; n< this.spu.categorySpecValue[unSelectBom[1]].length; n++)
                {
                    var itemL3 = _.find(this.skuSpec, {bom: unSelectBom[1]});
                    itemL3.val = this.spu.categorySpecValue[unSelectBom[1]][n];

                    if(this.canSelectSpec('', ''))
                    {
                        return;
                    }
                }

            }
        }

    };

    Product.prototype.selectSpec = function(bom, val){

        console.log(bom + " " + val);
        console.log(this.skuSpec);
        if (!this.canSelectSpec(bom, val))
        {
            var index = -1;
            for (var i=0; i<this.spu.categorySpec.length ; i++)
            {
                if(this.spu.categorySpec[i].bom == bom)
                {
                    index = i;
                }
            }
            if(index == this.spu.categorySpec.length-1) //不是第一个不可以选的
            {
                return;
            }
            else
            {
                this.checkSpecCanSelect(bom, val)
            }
        }

        console.log(this.skuSpec);
        var item = _.find(this.skuSpec, {bom: bom});
        item.val = val;
        this.updateSku();
    };

    Product.prototype.canSelectSpecPrev = function(bom, val){
        var _this = this;

        var indexPrev = -1;
        for(var i=0; i<this.spu.categorySpec.length; i++)
        {
            if(this.spu.categorySpec[i].bom == bom)
            {
                indexPrev = i;
                break;
            }
        }

        var skuKey = "";
        for(var i=0; i<this.spu.categorySpec.length; i++)
        {
            if(i < indexPrev)
            {
                var preSpec = _.find(this.skuSpec, {bom: this.spu.categorySpec[i].bom});
                skuKey += preSpec.val;
            }
        }

        skuKey += val;

        console.log(indexPrev + " " + skuKey);
        if(indexPrev == 0 )
        {
            //第0个，全部有效
            return true;
        }
        else if(indexPrev == 1 && this.spu.categorySpec.length >2)
        {
            for (var m = 0; m < this.spu.categorySpecValue[this.spu.categorySpec[indexPrev+1].bom].length; m++)
            {
                console.log(indexPrev + " " + skuKey);

                if(this.spu.sku[skuKey+this.spu.categorySpecValue[this.spu.categorySpec[indexPrev+1].bom][m]])
                    return true;
            }
        }
        else
        {
            return !!this.spu.sku[skuKey];
        }

        return false;
    };
    Product.prototype.canSelectSpec = function(bom, val){
        var _this = this;
        // console.log(this.spu.sku);

        var skuKey = _.map(this.spu.categorySpec, function(o){
            if (o.bom === bom) return val;
            var item = _.find(_this.skuSpec, {bom: o.bom});
            return item ? item.val : '';
        }).join('') || '';
        return !!this.spu.sku[skuKey];
    };

    function setProduct(data){
        product = new Product(data);

        return product;
    }
    function getProduct(){
        return product;
    }

    function getSpuBase(){
        return product.spu.base;
    }
    function getSpuExtraBase(){
        return product.spuExtra.basic;
    }
    function getBestBuy(){
        return product.bestBuy;
    }
    function getNextSku(){
        return product.nextSku;
    }

    function genProductDetailLink(id){
        switch(product.category){
            case 'grocery':
                return Utils.genPageLink('/grocery-detail?id='+id);
            case 'gallery':
                return Utils.genPageLink('/gallery-detail?id='+id);
            default:
                return Utils.genPageLink('/furniture-detail?id='+id);
        }
    }

    return {
        setProduct: setProduct,
        getProduct: getProduct,
        getSpuBase: getSpuBase,
        getBestBuy: getBestBuy,
        getNextSku: getNextSku,
        genProductDetailLink: genProductDetailLink,
        getSpuExtraBase: getSpuExtraBase
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/store.js
// module id = 101
// module chunks = 0